import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'wowjs/css/libs/animate.css';
import BaiduMap from 'vue-baidu-map'
// import Vconsole from 'vconsole';
// new Vconsole();

// 文章图片附件地址，后拼接附件id
Vue.prototype.$srcUrl = "http://oa2.sunutech.net:8081/x_cms_assemble_control/jaxrs/anonymous/fileinfo/download/document/";
// 文章非附件图片地址处理
Vue.prototype.$srcHandle = (id) => {
    return `http://oa2.sunutech.net:20020/x_file_assemble_control/jaxrs/file/${id}/download/stream`;
}
Vue.prototype.$map = {
    //(1) 文档id
    "carousel": "68daf4df-97b4-447d-83d2-fee6934bd1f0", //首页轮播图
    "homeprofile": "9256ce55-f85d-4728-a741-09ddb87781bf", //首页简介图
    "partner": "e5a856f9-25d8-4dfc-8454-e8f33081b140", //首页合作伙伴
    "aboutcompany": "3e1d383d-8537-40d2-b830-5d2f3ff02cb8", //主营业务-公司概况
    "companyregion": "356211c3-6d9c-48c7-854f-02f908a07662", //主营业务-地区分布
    "concepts": "c9be9e17-40cf-4771-8d25-87d9fd709c24", //主营业务-经营理念
    "businessscope": "ecadf4e7-b9fc-40ba-bb3b-fe80aecd3c4a", //主营业务-业务范畴
    // 顶部图片
    "profile": "fb7d0172-fd5c-4e66-8722-2258096a812a", //公司简介
    "business": "67eac2be-5cbf-4362-82ee-e71a46bc61d9", //主营业务
    "solution": "f5fe75df-bf90-4a09-a4c3-830a07e05eaa", //解决方案
    "detail": "f5fe75df-bf90-4a09-a4c3-830a07e05eaa", // 文档详情
    "news": "a0bcca9c-e89c-4c5a-9406-7a9d99805035", //新闻动态
    "newsdetail": "a0bcca9c-e89c-4c5a-9406-7a9d99805035", //新闻动态详情
    "cases": "df4a14de-0a78-411a-bc70-894703192aba", //项目案例
    "experience": "1ea6dfa4-5a71-48bc-ac91-90d9d4a7531b", //产品体验
    "aboutus": "1f36e49c-6822-494a-8599-fa50f360f58b", //核心技术
    // "core": "1f36e49c-6822-494a-8599-fa50f360f58b",  //核心技术
    "recruitment": "89b1a24f-9aee-49c6-9928-66eb9c5a0cb7", //加入我们
    // "contactus": "5f82012d-4180-4915-8a36-556d5f41a0f4",  //关于我们 

    //关于尚优-底部
    "aboutsunuId": "695ab6e1-4653-4b66-88fe-a38a8ca784b4",
    // 联系我们
    "cq": "66ff215c-5f2b-4c35-838b-914757d2d17e", //重庆地区
    // 其他地区id待定？？？
    //(2) 栏目id
    "solucategoryId": "63e16679-b465-4b9b-98aa-828209c8ba16", //解决方案
    "expcategoryId": "438fc441-f90e-4626-8b8d-4502a2310ff3", //产品体验
    "corecategoryId": "f510f5c3-4f39-46eb-b7f3-ad45ac3f4a40", //核心技术
    // "casescategoryId":"e6e5b639-22c1-4211-8c49-e0f484ffbe80",  //项目案例
    "buscategoryId": "1742c039-c2c0-4e30-a3de-dd1680fed96e", //主营业务
    "newscategoryId": "406ed8b3-56eb-4473-8480-538031022877", // 企业新闻  
    "news2categoryId": "2fcfd6b3-a081-417f-8d1c-632f185ef4d8", // 行业动态  
    "honorcategoryId": "e20b6a7d-e4a3-4741-b00c-752282e7d533", // 公司简介- 荣誉 
    "qualificationsId": "157d2f4c-104e-43e4-a1f7-882c2323c83c", // 公司简介- 资质 
    "recruitcategoryId": "9dd60f1d-1d59-4346-a664-687625c8e9e6", // 关于我们-人才招聘
    //(3) appid
    "casescategoryId": "d13c9144-7cc1-4c36-b4fa-9acb69b167db", //项目案例
    "newsappId": "81e72463-40f8-43a1-bbdc-78542a46a652", //新闻动态

}

Vue.use(ElementUI);
Vue.use(BaiduMap, {
    ak: 'WXBEIqdj43GLnsgcD4fU0u3SrkcL9Kzp' //  在此输入你自己的百度地图ak
})
Vue.config.productionTip = false;

//超出多少文字显示省略号
Vue.filter('ellipsis', (value) => {
        const cNumber = '400'
        if (!value) return ''
        if (value.length > cNumber) {
            return value.slice(0, cNumber) + '...'
        }
        return value
    },

);



new Vue({
    router,
    render: h => h(App),
}).$mount('#app')